import styled from 'styled-components';
import { TokenName } from '@mewssystems/design-tokens';
import { FOCUS_OUTLINE, getToken, Size, Sized } from '@optimus-web/common';
import {
    ANIMATION_CURVE,
    ANIMATION_DURATION,
    Component,
    Decision,
    getComponentVariableToken,
    OPACITY,
} from '@optimus-web/local-tokens';

const getBareIconButtonToken = getComponentVariableToken(Component.BareIconButton, 'variant');

export const getBareIconButtonDimensions = ({ size }: { size?: Size }) => {
    switch (size) {
        case 'small':
            return 16;
        case 'large':
            return 32;
        default:
            return 24;
    }
};

export const BareIconButtonElement = styled.button<Sized>`
    padding: 0;
    background: transparent;
    border: 0;
    cursor: pointer;
    color: ${getToken(TokenName.TEXT_STATIC_PRIMARY)};
    transition-property: color;
    transition-timing-function: ${ANIMATION_CURVE.default};
    transition-duration: ${ANIMATION_DURATION.fast}ms;
    height: ${getBareIconButtonDimensions}px;
    width: ${getBareIconButtonDimensions}px;
    ${FOCUS_OUTLINE}
    font-size: 0;

    &:disabled {
        opacity: ${OPACITY.disabled};
        /* Firefox workaround for bubbling events when disabled */
        pointer-events: none;
    }

    &:hover:enabled {
        color: ${getBareIconButtonToken(Decision.Color, { state: 'hover' })};
    }

    &:active:enabled {
        color: ${getBareIconButtonToken(Decision.Color, { state: 'active' })};
    }
`;
